import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CART_ITEM from '../../constants/cartItems';
import { IMAGE_SIZE_CODE } from '../../../../constants/image-size-codes';
import CartItemPhotoPreview from './CartItemPhotoPreview';
import TrashIcon from '../../../../components/icons/TrashIcon';
import { getDigitalDownloadCartItemPrice } from '../../redux/helpers';
import SaveIcon from '../../../../components/icons/SaveIcon';
import CheckoutCartItemPriceDisplay from './CheckoutCartItemPriceDisplay';
import CartItemVendor from './CartItemVendor';
import { getAsset } from '../../../../util/assets';
import CheckoutItemQuantityInput from './CheckoutItemQuantityInput';
import IdentityAvatar from '../../../../containers/global/identity/IdentityAvatarContainer';

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf([CART_ITEM.DIGITAL_DOWNLOAD]).isRequired,
    photo: PropTypes.shape({
      id: PropTypes.string.isRequired,
      thumbnail_urls: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
          size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  pricing: PropTypes.shape({
    price: PropTypes.object,
    discount_price: PropTypes.object,
  }),
  loading: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  watermarkSettings: PropTypes.shape({
    wallpaperCustomText: PropTypes.string,
    wallpaperFontSize: PropTypes.number,
  }),
};

const DigitalDownloadCartItem = ({
  item,
  loading,
  pricing,
  onRemove,
  onUpdate,
  watermarkSettings,
}) => {
  const { identity, prePaid: isPrepaid, quantity } = item;
  const price = getDigitalDownloadCartItemPrice(item);

  return (
    <div className="checkout-cart-item checkout-digital-download-cart-item">
      <div className="checkout-cart-item-content">
        <div className="checkout-cart-item-figure">
          {isPrepaid ? (
            <Fragment>
              <div className="purchasing-option-item-thumb">
                <img
                  src={getAsset('/digital-download-illustration.svg')}
                  width="62px"
                  alt=""
                />
              </div>
              <IdentityAvatar identity={identity} />
            </Fragment>
          ) : (
            <CartItemPhotoPreview
              photo={item.photo}
              watermarkSettings={watermarkSettings}
            >
              <span className="checkout-cart-item-photo-icon">
                <SaveIcon color="#0d84fe" size={18} />
              </span>
            </CartItemPhotoPreview>
          )}
        </div>

        <div className="checkout-cart-item-info">
          {isPrepaid ? (
            <Fragment>
              <span className="checkout-cart-item-title d-block">
                Digital Download
              </span>
              <CheckoutCartItemPriceDisplay
                clientPrice={price}
                pricing={pricing}
                loading={loading}
                quantity={quantity}
              />

              <div className="checkout-cart-item-info-actions mt-2">
                <CheckoutItemQuantityInput
                  onChange={value =>
                    onUpdate(item.id, {
                      quantity: value,
                    })
                  }
                  value={item.quantity}
                />

                <button
                  className="checkout-cart-item-btn-remove"
                  onClick={() => onRemove(item.id)}
                >
                  <TrashIcon color="#fe5851" size={18} />
                </button>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <span className="checkout-cart-item-title">
                Digital Download
                <button
                  className="checkout-cart-item-btn-remove"
                  onClick={() => onRemove(item.id)}
                >
                  <TrashIcon color="#fe5851" size={18} />
                </button>
              </span>

              <CheckoutCartItemPriceDisplay
                clientPrice={price}
                pricing={pricing}
                loading={loading}
              />
              <CartItemVendor cartItem={item} />

              <div className="checkout-cart-item-description">
                Hi&ndash;Res digital download for this photo.
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

DigitalDownloadCartItem.propTypes = propTypes;

export default DigitalDownloadCartItem;
